import { Page } from '@/types'
import { AxiosInstance } from 'axios'
import axiosInstance from '.'
import { AddressUnit } from './placeToVisit'

export interface LotSellerRequest {
  type: string
  firstname: string
  name: string
  businessReason: string
  address: AddressUnit
  phonenumber: string
  email: string
}

export interface LotSellerDto {
  id: number
  type: string

  firstname: string
  name: string
  businessReason: string
  address: AddressUnit
  phonenumber: string
  email: string

  createdTime: string
  updatedTime:string
}

class LotSellerApi {
  private axios: AxiosInstance

  public constructor(axios: AxiosInstance) {
    this.axios = axios
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async getAllLotSellers(params: any): Promise<Page<LotSellerDto>> {
    const axiosResponse = await this.axios.get('/lot-seller', { params })
    return axiosResponse.data
  }

  public create(request: LotSellerRequest) {
    return this.axios.post('/lot-seller', request)
  }

  public update(id: number, request: LotSellerRequest) {
    return this.axios.put(`/lot-seller/${id}`, request)
  }
}

export const lotSellerApi = new LotSellerApi(axiosInstance)
